
import { RootState } from '..';
import { useTypedSelector } from '../../hooks/useTypedSelector';

export const useLoginSelector = () =>
  useTypedSelector((state: RootState) => state.login);